import React, { useEffect, useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { buildUrl } from '../services/api';

export default function AcceptInvitePage() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [status, setStatus] = useState('accepting');
  const [error, setError] = useState('');

  useEffect(() => {
    const token = searchParams.get('token');
    const access = localStorage.getItem('access_token');
    if (!token) {
      setStatus('error');
      setError('Missing invite token.');
      return;
    }
    if (!access) {
      // Persist token and send user to register/login
      try { localStorage.setItem('pending_invite_token', token); } catch (_) {}
      setStatus('needs_auth');
      // Prefer register, but user can choose either
      navigate('/register');
      return;
    }
    const accept = async () => {
      try {
        const res = await fetch(buildUrl('/family/invites/accept'), {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${access}`
          },
          body: JSON.stringify({ token })
        });
        if (!res.ok) {
          const txt = await res.text();
          throw new Error(txt || 'Failed to accept invite');
        }
        setStatus('accepted');
        setTimeout(() => navigate('/dashboard'), 1500);
      } catch (e) {
        setStatus('error');
        setError('Unable to accept invite. It may be invalid or expired.');
      }
    };
    accept();
  }, [searchParams, navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <div className="bg-white p-8 rounded-xl border w-full max-w-md text-center">
        {status === 'accepting' && (
          <>
            <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-red-400 mx-auto mb-4"></div>
            <p className="text-gray-700">Accepting invite...</p>
          </>
        )}
        {status === 'accepted' && (
          <>
            <div className="mx-auto mb-4 w-12 h-12 rounded-full bg-green-100 flex items-center justify-center">
              <svg className="w-6 h-6 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
              </svg>
            </div>
            <p className="text-gray-700">Invite accepted! Redirecting...</p>
          </>
        )}
        {status === 'needs_auth' && (
          <>
            <div className="mx-auto mb-4 w-12 h-12 rounded-full bg-blue-100 flex items-center justify-center">
              <svg className="w-6 h-6 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 16h-1v-4h-1m1-4h.01M12 6a9 9 0 100 18 9 9 0 000-18z" />
              </svg>
            </div>
            <p className="text-gray-700 mb-4">Create an account or log in to accept your invite. We saved your invite and will apply it after you sign in.</p>
            <div className="flex items-center justify-center space-x-2">
              <button onClick={() => navigate('/register')} className="px-4 py-2 bg-red-400 text-white rounded">Register</button>
              <button onClick={() => navigate('/login')} className="px-4 py-2 bg-gray-200 rounded">Log in</button>
            </div>
          </>
        )}
        {status === 'error' && (
          <>
            <div className="mx-auto mb-4 w-12 h-12 rounded-full bg-red-100 flex items-center justify-center">
              <svg className="w-6 h-6 text-red-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 9v2m0 4h.01M12 5a7 7 0 100 14 7 7 0 000-14z" />
              </svg>
            </div>
            <p className="text-gray-700 mb-2">{error}</p>
            <button onClick={() => navigate('/dashboard')} className="px-4 py-2 bg-red-400 text-white rounded">
              Go to Dashboard
            </button>
          </>
        )}
      </div>
    </div>
  );
}








